import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ShippingAddress.css";
import * as actions from "../../Store/Actions/index";
import { connect } from "react-redux";
import Form from "react-bootstrap/Form";
import Footer from "../../Components/Footer/Footer";
import PriceDetail from "../../Components/PriceDetail/PriceDetail";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Link as Router } from "react-router-dom";
class ShippingAddress extends Component {
  
  state = {
    fullName: null,
    email: null,
    phone: null,
    address: null,
    country: null,
    state: null,
    city: null,
    pincode: null,
    errors: {
      fullName: "",
      email: "",
      phone: "",
      address: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
    userAddress: [],
    shippingCharge: false,
    routes: {
      "/": "Home",
      "/cart": "Cart",
      "/cart/shipping": "Shipping",
    },
  };

  componentDidMount() {
    this.props.country();
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    const validEmailRegex = RegExp(
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    );

    switch (name) {
      case "fullName":
        errors.fullName =
          value.length < 0 ? "Full Name must be 5 characters long!" : "";
        break;
      case "email":
        errors.email = validEmailRegex.test(value) ? "" : "Email is not valid!";
        break;
      case "phone":
        errors.phone = value.length < 10 ? "Phone must be 10 digit long!" : "";
        break;
      case "address":
        errors.address =
          value.length < 3 ? "Adress must be atleast 3 characters long!" : "";
        break;
      case "country":
        errors.country =
          value.length < 2 ? "country must be atleasr 1 characters long!" : "";
        break;
      case "state":
        errors.state =
          value.length < 3 ? "State must be 3 characters long!" : "";
        break;
      case "city":
        errors.city = value.length < 3 ? "city must be 3 characters long!" : "";
        break;
      case "pincode":
        errors.pincode =
          value.length < 2 ? "Pincode must be 2 characters long!" : "";
        break;
      default:
        break;
    }
    if (name === "country") {
      if (value !== "India") {
        this.setState({ shippingCharge: true });
      } else {
        this.setState({ shippingCharge: false });
      }
    }

    this.setState({ errors, [name]: value });
  };
  handleSubmit = (event) => {
    event.preventDefault();

    const validateForm = ({ errors, ...rest }) => {
      let valid = true;
      Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
      Object.values(rest).forEach((val) => {
        val == null && (valid = false);
      });
      return valid;
    };
    if (validateForm(this.state)) {
      
      let payload = {
        name: this.state.fullName,
        email: this.state.email,
        address: this.state.address,
        state: this.state.state,
        city: this.state.city,
        country: this.state.country,
        zipcode: this.state.pincode,
        phone: this.state.phone,
      };
      this.props.address(payload);
      this.props.history.push("/cart/shipping/ordersummary");
    } else {
      console.info("inValid Form");
    }
  };
  render() {
  document.title = "VK Global Publications | Shipping"

    return (
      <div>
        <div className="section2 cart-section">
          <Container>
          <h3 className="  cataloguebreadcrumbs cartbread float-right">
              <Router>
                <Breadcrumbs mappedRoutes={this.state.routes} />
              </Router>
            </h3>
            <h3 className="cart">Your Address</h3>

            <div className="box-container">
              <Row className="cartRow">
                <Col className="cartbox-container" sm={8}>
                  <div className="boxCart shippingCart">
                    <h3>Enter Address</h3>
                    <div className="form-container">
                      <Form.Group controlId="formGridEmail">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                          className={
                            this.state.errors.fullName.length > 0
                              ? "errorBox"
                              : ""
                          }
                          type="text"
                          name="fullName"
                          placeholder="Enter name"
                          onChange={this.handleChange}
                        />
                        {this.state.errors.fullName.length > 0 && (
                          <span className="error">
                            {this.state.errors.fullName}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Row>
                        <Form.Group as={Col} controlId="formGridEmail">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            name="email"
                            className={
                              this.state.errors.email.length > 0
                                ? "errorBox"
                                : ""
                            }
                            type="email"
                            placeholder="Enter email"
                            onChange={this.handleChange}
                          />
                          {this.state.errors.email.length > 0 && (
                            <span className="error">
                              {this.state.errors.email}
                            </span>
                          )}
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridPassword">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            name="phone"
                            className={
                              this.state.errors.phone.length > 0
                                ? "errorBox"
                                : ""
                            }
                            type="number"
                            placeholder="Phone"
                            onChange={this.handleChange}
                          />
                          {this.state.errors.phone.length > 0 && (
                            <span className="error">
                              {this.state.errors.phone}
                            </span>
                          )}
                        </Form.Group>
                      </Form.Row>

                      <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Billing Address</Form.Label>
                        <Form.Control
                          name="address"
                          as="textarea"
                          className={
                            this.state.errors.address.length > 0
                              ? "errorBox"
                              : ""
                          }
                          rows="3"
                          onChange={this.handleChange}
                        />
                        {this.state.errors.address.length > 0 && (
                          <span className="error">
                            {this.state.errors.address}
                          </span>
                        )}
                      </Form.Group>

                      <Form.Row size="lg">
                        <Form.Group as={Col} controlId="formGridState">
                          <Form.Label>Country</Form.Label>
                          <Form.Control
                            ref="country"
                            name="country"
                            className={
                              this.state.errors.country.length > 0
                                ? "errorBox"
                                : ""
                            }
                            as="select"
                            onChange={this.handleChange}
                          >
                            <option selected disabled>
                              Choose
                            </option>
                            {this.props.countries.map((country) => {
                              return <option>{country.name}</option>;
                            })}
                          </Form.Control>
                          {this.state.country !== 'India' ? (
                            <span className="shippingChrgeWarning">
                               {/* 450/per book will be charged,if outside india.  */}
                               International Shipping Not allowed 
                            </span>
                          ):''}
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridCity">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            name="state"
                            placeholder="State"
                            className={
                              this.state.errors.state.length > 0
                                ? "errorBox"
                                : ""
                            }
                            onChange={this.handleChange}
                          />
                          {this.state.errors.state.length > 0 && (
                            <span className="error">
                              {this.state.errors.state}
                            </span>
                          )}
                        </Form.Group>
                      </Form.Row>
                      <Form.Row>
                        <Form.Group as={Col} controlId="formGridZip">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            name="city"
                            placeholder="City"
                            type="text"
                            className={
                              this.state.errors.city.length > 0
                                ? "errorBox"
                                : ""
                            }
                            onChange={this.handleChange}
                          />
                          {this.state.errors.city.length > 0 && (
                            <span className="error">
                              {this.state.errors.city}
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridZip">
                          <Form.Label>Pin Code</Form.Label>
                          <Form.Control
                            name="pincode"
                            className={
                              this.state.errors.pincode.length > 0
                                ? "errorBox"
                                : ""
                            }
                            placeholder="Pin code"
                            type="number"
                            onChange={this.handleChange}
                          />
                          {this.state.errors.pincode.length > 0 && (
                            <span className="error">
                              {this.state.errors.pincode}
                            </span>
                          )}
                        </Form.Group>
                      </Form.Row>
                    </div>
                  </div>
                </Col>
                <Col className="pricebox-container " sm={4}>
                  <div className="priceBox shippingCart">
                    <h3>Price Details</h3>
                    <PriceDetail
                      route={this.props}
                      cartBook={this.props.cartBook}
                      clicked={this.handleSubmit}
                      country={this.state.shippingCharge}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cartBook: state.book.addedBooks,
    countries: state.book.countries,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    country: () => dispatch(actions.storeCountry()),
    address: (userAddress) =>
      dispatch(actions.userShippingAddress(userAddress)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddress);
